/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import DeleteAction from './DeleteAction/index'
import PreviewImage from 'DesignSystem/PreviewImage/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/UploadedImages/Content/Images/Content/TemporaryImage/Content",
  innerRef,
  isDragging
  
}) {
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let resourceObjectMetaUrlValueData = fromData.useDataValue({ viewPath,
context: 'resource_object_meta',
path: 'url',
})
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let resourceObjectMetaNameValueData = fromData.useDataValue({ viewPath,
context: 'resource_object_meta',
path: 'name',
})
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 alingItems="center"
 ref={innerRef}
 style={{'--bc-1-Z1Yf8zk': dtColorsNeutral300,'--bc-2-Z1Yf8zk': dtColorsWhite,'--btlr-3-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-4-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bblr-5-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-6-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--mt-7-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--mb-8-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--o-9-Z1Yf8zk': isDragging ? 0.5 : 1,'--c-10-Z1Yf8zk': isDragging ? "grabbing" : "grab"}}
 className={`views-block ${styles.Vertical}`}
>
<PreviewImage
  viewPath={`${viewPath}/PreviewImage`}
 data="resource_object_meta.url"
 url={resourceObjectMetaUrlValueData}
 width={120}
 height={100}
 marginTop={dtSpaceXxs}
 marginBottom={dtSpaceXxs}
 marginLeft={dtSpaceXxs}
 marginRight={dtSpaceXxs}
/>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--bc-2-Z1Yf8zk': dtColorsNeutral200,'--pt-11-Z1Yf8zk': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--pb-12-Z1Yf8zk': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--pl-13-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pr-14-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 width="80%"
 data="resource_object_meta.name"
 whiteSpace="nowrap"
 size="tiny"
 overflowX="hidden"
 text={resourceObjectMetaNameValueData}
/>
<DeleteAction
  viewPath={`${viewPath}/DeleteAction`}
/>
</div>
</div>
{children}
</React.Fragment>)
}